import Vue from 'vue';

export default {
	RESET_ALLY_STATE(state: any) {
		Vue.set(state, 'allyPlaceholder', 'What do you want to do?');
		Vue.set(state, 'list', []);
		Vue.set(state, 'crumbs', []);
		Vue.set(state, 'launcherState', 'INIT');
		Vue.set(state, 'dataPanelSide', '');	
		Vue.set(state, 'rows', []);	
		Vue.set(state, 'columns', []);
	},
	OPEN_ALLY({ open }: any) {
		open = true;
	},
	CLOSE_ALLY({ open }: any) {
		open = false;
	},
	IS_LOADING(state: any) {
		Vue.set(state, 'loading', true);
	},
	DONE_LOADING(state: any) {
		Vue.set(state, 'loading', false);
	},
	SET_AUTH_STATE(state: any, isLoggedIn: boolean) {
		Vue.set(state, 'loggedIn', isLoggedIn);
	},
	SET_STATUS({ status }: any, newStatus: string) {
		status = newStatus;
	},
	SET_CUR_URL(state: any, curURL: string) {
		Vue.set(state, 'curURL', curURL);
	},
	UPDATE_PLACEHOLDER(state: any, placeholder: string) {
		Vue.set(state, 'allyPlaceholder', placeholder);
	},
	RESET_PLACEHOLDER(state: any, placeholder: string) {
		Vue.set(state, 'allyPlaceholder', 'What do you want to do?');
	},
	SET_USER_INFO(state: any, newUserIdentifier: any) {
		Vue.set(state, 'userIdentifier', newUserIdentifier);
	},
	SET_USER(state: any, user: any) {
		Vue.set(state, 'user', user);
	},
	SET_GK(state: any, gk: any) {
		Vue.set(state, 'gk', gk);
	},
	CLEAR_GK(state: any) {
		Vue.set(state, 'gk', {});
	},
	SET_LIST(state: any, list: any) {
		Vue.set(state, 'list', list);
	},
	RESET_LIST(state: any) {
		Vue.set(state, 'list', []);
	},
	SET_INPUT_TEXT(state: any, inputText: any) {
		Vue.set(state, 'storeInputText', inputText);
	},
	UPDATE_ACTIVE_IDX(state: any, newIdx: number) {
		Vue.set(state, 'activeIdx', newIdx);
	},
	UPDATE_DISPLAY_LIST_LENGTH(state: any, displayListLength: number) {
		Vue.set(state, 'displayListLength', displayListLength);
	},
	UPDATE_CRUMBS(state: any, crumbs: any) {
		Vue.set(state, 'crumbs', crumbs);
	},
	SET_AUTO_COMPLETE_TEXT(state: any, autoCompleteText: string) {
		Vue.set(state, 'autoCompleteText', autoCompleteText);
	},
	SET_DATA_PANEL_SIDE(state: any, dataPanelSide: string) {
		Vue.set(state, 'dataPanelSide', dataPanelSide);	
	},
	SET_DATA_PANEL_DATA(state: any, dataPanelData: any) {
		let rows = dataPanelData.data.rowsFromStart;
		if (dataPanelData.splitData) {
			rows.push({ empty: true });
			rows = rows.concat(dataPanelData.data.rowsFromEnd);
		}
		Vue.set(state, 'splitData', dataPanelData.splitData);
		Vue.set(state, 'totalRows', dataPanelData.total);
		Vue.set(state, 'rows', rows);	
		Vue.set(state, 'columns', dataPanelData.data.columns);
	},
	RESET_DATA_PANEL_DATA(state: any) {
		Vue.set(state, 'rows', []);	
		Vue.set(state, 'columns', []);			
	},
	SET_LAUNCHER_STATE(state: any, launcherState: string) {
		Vue.set(state, 'launcherState', launcherState);
	},
	SET_PREVIEW_STATE(state: any, previewState: string) {
		Vue.set(state, 'previewState', previewState);
	},
	SET_IF_ONBOARDING(state: any, ifOnboarding: boolean) {
		Vue.set(state, 'ifOnboarding', ifOnboarding);
	},
	SET_OB_ALLOWED_OPTIONS(state: any, allowedOptions: string[]) {
		Vue.set(state, 'obAllowedOptions', allowedOptions);
	}
};
